<template>
  <TabbedPortletOpportunity>
    <div class="d-flex justify-content-between OpportunityTitleAndDate align-items-center" slot="header">
      <div class="my-1">
        <div class="OpportunityEdit my-3">
          <h1 class="text-danger OpportunityEdit-title" v-show="!isEditingTitle"  @click="toggleTitle">
            <span class="mr-2" v-if="$v[validationGroupName].opportunityDetailsTab.opportunityName.$model">
              {{ $v[validationGroupName].opportunityDetailsTab.opportunityName.$model }}
            </span>
            <span class="mr-2" v-else>Untitled</span>
            <font-awesome-icon :icon="['fas', 'pen']" size="xs" class="mb-1" v-if="!isCompletedQuote" />
          </h1>
          <div v-show="isEditingTitle">
            <BaseInput
              class="OpportunityTitleInput"
              ref="editingTitle"
              type="text"
              placeholder="Opportunity name goes here"
              :isLargeSize="true"
              v-model="$v[validationGroupName].opportunityDetailsTab.opportunityName.$model"
              @blur="$v[validationGroupName].opportunityDetailsTab.opportunityName.$touch()"
              :validator="$v[validationGroupName].opportunityDetailsTab.opportunityName"
              @keyup.enter="saveEditingTitle"
              @keyup.esc="toggleTitle" />
              <small style="display:none;" class="text-white">Press escape to cancel editing.</small>
          </div>
        </div>
        <div class="OpportunityDates OpportunityDates-desktop d-flex my-3">
          <h5 class="fw-600" style="color:#c1323e;">Type: <span style="color:#00a7cb;">{{ exportType }}</span></h5>
          <font-awesome-icon :icon="['fas', 'calendar-alt']" size="lg" class="ml-4"/>
          <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries && opportunitySource.itineraries.length">{{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].fromitinerary | custom-date }}</h5>
          <font-awesome-icon class="mx-4" :icon="['fas', 'long-arrow-alt-right']" size="lg" />
          <font-awesome-icon :icon="['fas', 'calendar-alt']" size="lg" />]
          <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries && opportunitySource.itineraries.length">{{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].toitinerary | custom-date }}</h5>
          <font-awesome-icon class="ml-4" :icon="['fas', 'map-marker-alt']" size="lg" />
          <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries && opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited && Array.isArray(opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited)">
            {{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited | custom-join('name') }}
          </h5>
        </div>

        <div class="OpportunityDates OpportunityDates-mobile my-3">

          <div class="row">
            <div class="col-12 my-2"><h5 class="fw-600" style="color:#c1323e;">
            Type: <span style="color:#00a7cb;">{{ exportType }}</span></h5>
            </div>
            <div class="col-12 my-2">
              <div class="d-flex my-1">
                <font-awesome-icon :icon="['fas', 'calendar-alt']" size="lg"/>
                <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries">{{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].fromitinerary | custom-date }}</h5>
              </div>

              <font-awesome-icon class="my-1" :icon="['fas', 'long-arrow-alt-down']" size="lg" />

              <div class="d-flex my-1">
                <font-awesome-icon :icon="['fas', 'calendar-alt']" size="lg" />
                <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries">{{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].toitinerary | custom-date }}</h5>
              </div>
            </div>
            <div class="col-12 my-2">
              <div class="d-flex">
                <font-awesome-icon class="" :icon="['fas', 'map-marker-alt']" size="lg" />
                      <h5 class="ml-2 fw-600" v-if="opportunitySource && opportunitySource.itineraries && opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited && Array.isArray(opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited)">
                        {{ opportunitySource.itineraries[itinerarySourceTypeSelected.index].locations_visited | custom-join('name') }}
                      </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-self-start text-dark">
         <button
                type="button"
                data-toggle="tooltip" title="Print from browser"
                class="btn btn-md text-danger mt-4 mr-2 printPage"
                :class="{ 'disabled': !isLoading }"
                :disabled="!isLoading"
                @click="printPage">
                <font-awesome-icon :icon="['fas', 'print']" class="printPageIcon"/> Print</button>
        <button
          type="button"
          class="btn btn-info btn-wide mt-4"
          @click="suggestImages"
          :disabled="isSaving"
          v-if="false">
          <font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" v-if="isSaving" />
          Suggest images
        </button>
      </div>
    </div>
<!---->
    <TabbedPortletBody class="p-0 OpportunityBoxInfo">
      <div class="row no-gutters align-items-start">
        <div class="col-2 sticky-menu overflow-y-scroll">

          <ul class="kt-nav kt-nav--bold kt-nav--md-space kt-nav--v4--info pt-0" role="tablist">
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_DETAILS }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_DETAILS)">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                        <g><path class="cls-1" d="M56.08,17.26c7.64,0,15.27.14,22.9,0,8.33-.17,16.58,5.94,18.6,15.21a12,12,0,0,1,.21,2.6c0,6.35,0,12.7,0,19.06,0,1.22,0,2.48-1.61,2.4-1.41,0-1.68-1.15-1.67-2.45,0-5.67,0-11.37,0-17.06,0-9.8-6.61-16.48-16.27-16.48h-45a15.62,15.62,0,0,0-15.6,15.93q0,23.2,0,46.39A15.73,15.73,0,0,0,33.32,98.77c6.31,0,12.62,0,18.94,0,0.7,0,1.48-.21,2,0.47a2,2,0,0,1,.32,1.91c-0.3,1-1.19.9-2,.9-6.25,0-12.5-.12-18.75.05a17.86,17.86,0,0,1-13-4.7c-3.93-3.59-6.4-8-6.42-13.47q-0.11-24.3,0-48.6c0-9.25,8.46-17.92,17.55-18,8-.12,16,0,24.07,0v0Z"/><path class="cls-1" d="M100.92,70.26A4.84,4.84,0,0,1,99.39,74Q88.09,85.52,76.77,97a5.42,5.42,0,0,1-2.58,1.42c-3,.82-6.07,1.68-9.11,2.51a7.15,7.15,0,0,0-2.43,1.3,1.35,1.35,0,0,1-1.8-.16,1.3,1.3,0,0,1-.44-1.77c2.26-3.43,2.53-7.52,3.75-11.32a8.36,8.36,0,0,1,2-3.55C72.27,79.23,78.34,73,84.4,66.78c1.2-1.23,2.28-2.6,3.51-3.8,2.63-2.57,5.14-2.51,7.72.11,1.4,1.41,2.8,2.82,4.18,4.24A3.73,3.73,0,0,1,100.92,70.26ZM75,93.87a8.21,8.21,0,0,0,.79-0.65q6.9-7,13.81-14c0.84-.85.63-1.44-0.11-2.17-1.41-1.38-2.83-2.77-4.17-4.25-0.86-1-1.5-1-2.41,0-4.38,4.55-8.79,9-13.22,13.49-0.81.81-1,1.44-.07,2.28,1.52,1.48,3,3,4.47,4.54C74.39,93.34,74.7,93.58,75,93.87ZM97.7,70.23a1.32,1.32,0,0,0-.22-0.61c-1.6-1.64-3.22-3.3-4.88-4.92a1.25,1.25,0,0,0-1.78.15,19.82,19.82,0,0,0-1.57,1.51c-2.9,2.93-2.9,2.93.05,5.94,3.57,3.63,3.58,3.65,7.09,0A3,3,0,0,0,97.7,70.23ZM66.33,97.09c1.63-.67,4-0.37,4.84-1.84,0.45-.77-1.9-2.17-2.9-3.37-0.09-.11-0.19-0.19-0.27-0.28-0.66-.62-1.08-0.32-1.31.39-0.4,1.39-.77,2.78-1.15,4.2C65.36,96.89,65.56,97.23,66.33,97.09Z"/><path class="cls-1" d="M70,39.37H57.18c-1.19,0-2.68.17-2.71-1.52s1.46-2,2.84-2c5.58,0,11.17,0,16.77,0H83a2.76,2.76,0,0,1,2.32.88,1.68,1.68,0,0,1,.15,1.73c-0.36.91-1.2,0.93-2,.93H70Z"/><path class="cls-1" d="M70.33,57.91H82.94c1.23,0,2.53,0,2.57,1.72S84.33,61.44,83,61.44q-13,0-26,0c-1.28,0-2.58-.21-2.53-1.79s1.32-1.76,2.63-1.75C61.53,57.93,65.93,57.91,70.33,57.91Z"/><path class="cls-1" d="M47.12,75.28a12,12,0,0,1-.82,1.35c-3.37,4-6.78,8-10.14,12a2,2,0,0,1-3.09.3c-2.13-1.65-4.24-3.35-6.39-5a1.58,1.58,0,0,1-.36-2.43,1.41,1.41,0,0,1,2.24-.3c1.49,1.09,3,2.19,4.39,3.38,0.93,0.81,1.5.92,2.37-.15,2.71-3.34,5.54-6.6,8.29-9.91a1.72,1.72,0,0,1,2.21-.74A2.36,2.36,0,0,1,47.12,75.28Z"/><path class="cls-1" d="M27.71,35.36c1.26,0.33,2.14,1.4,3.22,2.15C34.46,40,34.45,40,37.17,36.7q3.18-3.82,6.37-7.64c0.79-.95,1.66-1.28,2.72-0.49s0.76,1.77,0,2.69c-3.32,3.88-6.6,7.78-9.9,11.69-0.81,1-1.73,1.54-2.89.65-2.36-1.79-4.7-3.65-7-5.5A1.09,1.09,0,0,1,26,36.57,1.85,1.85,0,0,1,27.71,35.36Z"/><path class="cls-1" d="M34.41,65.88a1.81,1.81,0,0,1-1.26-.51c-2.12-1.64-4.27-3.28-6.41-5a1.63,1.63,0,0,1-.32-2.58c0.77-.95,1.59-0.6,2.41,0A50.06,50.06,0,0,1,32.91,61c1.29,1.26,1.93.61,2.78-.45,2.54-3.14,5.13-6.22,7.73-9.31,0.8-.94,1.66-1.83,2.94-0.6,0.65,0.65.93,1.24,0.25,2.06Q41.2,59,35.82,65.38A1.63,1.63,0,0,1,34.41,65.88Z"/></g>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Details
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_LETTER }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_LETTER)">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                    <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                        <g><path class="cls-1" d="M78.16,33.5c10.1,0,20.16,0,30.24,0a7.24,7.24,0,0,1,2.79.44,4.2,4.2,0,0,1,2.49,5q-3.61,17.9-7.24,35.85c-0.29,1.43-.57,2.88-0.87,4.3a7.45,7.45,0,0,1-7.28,6Q68,85,37.7,85.05c-2.88,0-4.63-1.14-5.08-3.49a8.91,8.91,0,0,1,.12-3.33c2.65-12.92,5.34-25.81,8-38.72a7.15,7.15,0,0,1,5-5.73,7,7,0,0,1,2.41-.27Q63.14,33.48,78.16,33.5ZM68,82.95q15.34,0,30.66,0a4,4,0,0,0,3.43-1.51,9.59,9.59,0,0,0,1.55-3.24c1-4.46,1.87-8.94,2.8-13.39q2.68-13,5.36-25.93a2.66,2.66,0,0,0-2.3-3.32,11.62,11.62,0,0,0-1.53-.14H47.91a5.2,5.2,0,0,0-5.34,4.52Q41,47.77,39.42,55.57c-1.62,8-3.25,16.11-4.83,24.14-0.46,2.25.43,3.24,2.76,3.24H68Z"/><path class="cls-1" d="M17.21,57.56H5.83c-0.71,0-1.63.21-1.61-1s0.9-1.1,1.65-1.11H25.13c1.13,0,2.25,0,3.38,0a3.46,3.46,0,0,1,1.29.25,1.17,1.17,0,0,1,.61.9,1.51,1.51,0,0,1-.72.87,2,2,0,0,1-.91.07H17.21Z"/><path class="cls-1" d="M24.71,39.89h7.37c0.75,0,1.3.13,1.31,1a1,1,0,0,1-1.23,1q-7.4,0-14.84,0a1,1,0,0,1-1.26-1.1,1,1,0,0,1,1.29-1h7.37Z"/><path class="cls-1" d="M19.39,71.71H13.86c-0.66,0-1.25-.11-1.25-1s0.61-1,1.27-1H25.13c0.68,0,1.24.11,1.24,1s-0.59,1-1.25,1H19.39Z"/><path class="cls-1" d="M72.21,65.09a6.75,6.75,0,0,1-4.37-2Q63,58,58.15,52.95L49.1,43.32c-1.43-1.51-2.88-3-4.29-4.55-0.38-.39-0.89-0.85-0.42-1.51s1.07-.78,1.82,0c2.19,2.31,4.37,4.61,6.55,6.93Q59,50.8,65.17,57.43c1.17,1.23,2.41,2.42,3.51,3.75,2,2.38,4.81,2.16,6.92.58Q82.25,56.89,88.91,52q10-7.35,20.08-14.68a1.06,1.06,0,0,1,.42-0.29,2.32,2.32,0,0,1,1.15,0,1.59,1.59,0,0,1,.07,1.33,18.55,18.55,0,0,1-2.51,2.07Q92.33,52,76.54,63.55A7.14,7.14,0,0,1,72.21,65.09Z"/></g>
                    </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Letter
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_ITINERARY }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_ITINERARY)">

                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                    <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                      <g><path class="st0" d="M18.4,44c-1.5-0.5-3.1-0.7-4.7-0.6c-0.7,0-0.8,0.3-0.8,0.9c-0.5,8.9,2.5,17.8,8.4,24.5
                      c4.5,5.3,10.6,9.1,17.4,10.8c1.4,0.4,1.7,0.8,1.5,1.8c-0.1,0.7-0.7,1.2-1.4,1.2c-0.1,0-0.3,0-0.4-0.1c-4.2-1-8.2-2.7-11.8-5
                      c-5.7-3.8-10.2-9-13.1-15.2c-1.8-3.7-2.9-7.8-3.3-11.9c-0.3-2.7-0.3-5.4,0-8.1c0.2-1.4,0.5-1.8,1.9-1.8c2.2-0.2,4.5,0,6.7,0.4
                      c0.6,0.2,1.1,0.4,1.7,0.7c1.6,0.9,1.9,2,0.8,3.5c-1.5,2-1.1,4.2-0.4,6.3c0.1,0.5,0.6,0.9,1.2,0.8c0.1,0,0.2-0.1,0.3-0.1
                      c2.9-1.7,5.1-4.4,6.2-7.6c0.3-1.2,0.3-2.4,0-3.5c-0.6-1.8,0.3-3.7,2.1-4.3c0.1,0,0.1,0,0.2-0.1c2.5-0.9,5.1-1,7.3,0.8
                      c1,0.7,1.6,1.7,1.8,2.9c0.5,3-0.3,6.1-2.2,8.4c-0.4,0.4-0.7,0.9-1,1.5c-1,1.8-0.8,2.5,0.9,3.5c2.9,1.8,4.5,6,3.8,9.6
                      c-0.3,1.6-0.7,3.1-1.4,4.6c-1,2.2-0.7,4.8,0.8,6.8c1.8,2.3,4.1,4.3,6.6,5.9c0.3,0.2,0.7,0.2,1,0.2c4.6-0.1,9.2-1.2,13.3-3.1
                      c7.6-3.6,13.7-9.8,17.2-17.5c1.7-3.6,2.6-7.6,2.8-11.6c0.1-2.3,0.1-4.7-0.2-7c-0.2-0.8,0.3-1.6,1-1.8c0.1,0-0.3-4.7-0.2-4.7
                      c0.9-0.1,1.9,5.1,2,6.2c1.3,11.6-1.6,21.8-9.7,30.4c-5.4,6-12.7,10-20.7,11.4c-2.1,0.4-4.2,0.6-6.3,0.6c-1-0.1-2-0.5-2.7-1.2
                      c-2.4-1.5-4.5-3.4-6.3-5.6c-2-2.7-3-5.7-1.6-9c1-2.1,1.6-4.5,1.5-6.8c-0.1-2-1.1-3.8-2.8-4.9c-3-2-3.6-4.6-1.6-7.7
                      c0.3-0.5,0.6-0.9,1-1.4c1.5-1.6,2.1-3.8,1.8-6C37,39.8,36,39.3,35,39c-1.1-0.5-2.4-0.3-3.3,0.5c-0.3,0.3-0.3,0.7-0.2,1.1
                      c1,4.1-0.8,7.3-3.3,10.3c-1.1,1.2-2.3,2.4-3.6,3.3c-2.9,2.1-5.8,1.1-6.8-2.4C17,49.2,17.2,46.4,18.4,44z"/>
                    <path class="st0" d="M47.3,8.6c3,0,6.1,0.4,9,1.1c0.8,0.1,1.5,0.8,1.4,1.7c0,0.1,0,0.3-0.1,0.4c-0.2,1.2,0.2,2.4,0.9,3.4
                      c0.6,1,0.9,2.1,0.8,3.2c0,2-0.3,4-1.1,5.9c-0.4,1.1-1.4,1.8-2.5,1.9c-1.8,0.3-3.5,1.2-4.7,2.6c-1,1.1-1,1.8-0.3,3.1
                      c1,1.8,2,3.6,3,5.4c0.8,1.5,1.2,1.5,2.1,0c0.8-1.3,1.5-2.8,2.2-4.2c0.2-0.5,0.5-0.9,0.8-1.4c1.7-2.7,4.9-2.8,6.9-0.2
                      c0.9,1.2,1.7,2.5,2.3,3.8c1.1,2.3,1.3,2.4,3.8,2.2c2.6-0.2,5.2-0.7,7.8-1.4c0.8-0.2,0.8-0.6,0.6-1.2c-1.6-4.5-4.1-8.7-7.4-12.2
                      c-3.4-3.7-7.5-6.6-12.1-8.6c-1.1-0.5-1.4-1.1-1-2s1.1-1.2,2.1-0.7C72.8,16.4,80.1,24.4,83.4,36c0.4,1.3,0.2,1.7-1,2.2
                      c-2.8,1.1-5.8,1.8-8.8,2c-1.2,0.1-2.4,0.2-3.7,0.2c-2.2-0.1-3.4-1.4-4.4-3.2c-0.6-1.2-1.3-2.4-2-3.5c-1.1-1.5-1.7-1.4-2.6,0.1
                      c-0.9,1.9-2,3.7-3.2,5.4c-0.3,0.5-0.7,0.9-1.1,1.3c-1,1.1-2.6,1.2-3.7,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-1.1-1.1-2-2.3-2.7-3.7
                      c-0.5-1.1-1.1-2.2-1.8-3.2c-2-2.7-1.1-5.3,0.9-7.2c1.5-1.6,3.6-2.7,5.8-2.9c0.5-0.1,0.8-0.5,0.8-0.9c0.4-1.6,0.6-3.2,0.7-4.8
                      c0-0.3-0.1-0.5-0.3-0.7c-0.8-1.1-1.4-2.4-1.5-3.8c0-0.6-0.4-1-1-1.1c-10-2-20.3,0.7-28.2,7.2c-5.4,4.3-9.4,10.2-11.3,16.8
                      c-0.3,0.9-2.7,7.6-3.9,7.2c-0.7-0.1,0.9-6.7,1-7.5c0-0.1,0-0.2,0.1-0.3c1.2-4.2,3.1-8.2,5.8-11.7C23.1,16,31.8,10.7,41.4,9.1
                      C43.4,8.8,45.3,8.6,47.3,8.6z"/>
                    <path class="st0" d="M46.1,94.1c0-2.6,0-2.5-2.6-2.7c-8.2-0.7-16.1-3.7-22.5-8.9c-5.4-4.2-9.8-9.7-12.8-15.9
                      c-2.3-4.7-3.6-9.8-3.8-15c-0.1-1.1-0.2-2.2-0.2-3.2s0.5-1.7,1.5-1.7c0.8,0,1.4,0.6,1.4,1.4c0,0.1,0,0.2,0,0.3
                      c0.1,4.9,1,9.8,2.7,14.5c1.6,4.1,3.8,7.9,6.7,11.2c3.5,4.2,7.8,7.7,12.6,10.2c5.3,2.6,11,4.1,16.9,4.3c8.7,0.4,17.3-2.1,24.4-7.1
                      c0.4-0.3,0.8-0.5,1.2-0.8c0.6-0.5,1.5-0.4,2,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.6,0.9,0,1.4-0.6,1.9c-4.6,3.4-9.9,5.9-15.5,7.2
                      c-2.5,0.6-5,1-7.5,1.2c-0.5-0.1-1.1,0.3-1.1,0.8c0,0.1,0,0.3,0,0.4c0.1,1.2,0.1,2.3-0.1,3.5c-0.1,0.7-0.7,1.2-1.4,1.2
                      c0,0-0.1,0-0.1,0c-0.7,0-1.3-0.5-1.3-1.2c0-0.1,0-0.1,0-0.2L46.1,94.1L46.1,94.1z"/>
                    <path class="st0" d="M64.1,60.7c-1.5,0.1-3.1-0.3-4.3-1.3c-1.6-1.2-3.4-2.2-5.2-3c-1.7-0.8-2.3-1.7-2.2-3.2c0.1-1.2,1-2.3,2.2-2.5
                      c0.9-0.3,1.8-0.3,2.7,0c0.6,0.3,1.4,0.1,1.7-0.5c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.2-0.2c1.2-1.6,3-2.7,5-3.1c1.7-0.4,3.5-0.7,5.3-0.8
                      c1.6,0,3,0.7,4.1,1.8c1,0.9,1.1,2.5,0.3,3.6c-0.4,0.6-0.9,1.2-1.5,1.7c-1.2,1.2-2.2,2.5-2.9,4.1C68.4,59.8,66.2,60.6,64.1,60.7z
                       M55.7,53.6c2.1,1,4,2.1,5.9,3.4c1.5,1.2,3.7,1,4.9-0.5c0.2-0.2,0.3-0.4,0.4-0.6c0.9-1.8,2-3.4,3.5-4.8c0.4-0.4,1.1-0.8,0.9-1.3
                      c-0.4-0.6-1.1-0.9-1.9-0.8c-0.3,0-0.6,0-0.9,0c-3,0.5-6.2,0.7-8,3.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.9-2.1,1.1-3.2,0.7
                      C56.6,53.4,56.1,53.4,55.7,53.6z"/>
                    <path class="st1" d="M50,76c-0.9,0-1.9-0.2-2.7-0.5c-3.6-1.4-4.8-4.3-3.2-7.7c1-2.3,2.8-4.1,5-5.3c1.7-1.1,3.9-0.8,5.2,0.8
                      c1.6,1.5,2.7,3.5,2.9,5.7C57.9,73.1,55,76,50,76z M50.2,71.4c1.3,0,2.4-0.1,2.7-1.5c-0.2-1.3-0.9-2.4-2-3.2c-1.3,0.8-2.3,2-2.8,3.5
                      C48.4,71.1,49.3,71.6,50.2,71.4L50.2,71.4z"/></g>
                    </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Itinerary
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_INCLUDED }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_INCLUDED)">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                        <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                          <path class="st0" d="M58.4,111.1C29.7,112,4.5,86.6,4.4,57.4S28.9,2.9,58.6,3c29.6,0,54.5,25.3,54,55.1
                            C112.2,86.8,87.4,112.1,58.4,111.1z M58.6,6.7C32.6,5.9,8,27.7,7.9,57S32,107.4,58,107.7c26.6,0.3,51.1-21.2,51.2-50.4
                            C109.2,27.8,84.5,5.9,58.6,6.7z"/>
                          <g class="st1">
                            <path class="st0" d="M88.4,60H60.9v27.5h-5V60H28.4v-5h27.5V27.5h5V55h27.5V60z"/>
                          </g>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Inclusions
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_MAP }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_MAP)">

                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                    <g> <path class="st0" d="M8,81.5h73.5c1.1,0,1.2-0.1,1-1.2c-0.3-2.7-0.6-5.4-0.9-8.1s-0.6-5.1-0.9-7.7s-0.5-5.1-0.8-7.6
                      s-0.6-5.2-0.9-7.8c-0.2-2.1-0.5-4.1-0.6-6.2c-0.1-1.4-0.1-1.4-1.5-1.4H64.9c-0.7,0.1-1.3-0.3-1.4-1c0-0.2,0-0.4,0-0.5
                      c0-0.5,0.4-1,0.9-1.1c0.4-0.1,0.7-0.1,1.1-0.2c4.8,0,9.6,0,14.4,0c0.5-0.1,0.9,0.2,1,0.6c0,0.1,0,0.2,0,0.4
                      c0.3,2.7,0.6,5.4,0.9,8.1s0.5,5.1,0.8,7.7s0.6,5.2,0.8,7.8c0.2,2.1,0.4,4.2,0.7,6.3s0.5,4.2,0.7,6.4s0.4,4.1,0.7,6.1
                      c0.1,0.4,0.1,0.9,0.2,1.3c0.1,0.6-0.1,1-0.8,0.9c-0.1,0-0.3,0-0.4,0H4.9c0.2-1.3,0.3-2.6,0.5-3.9c0.3-2.6,0.7-5.3,1-7.9
                      s0.6-5.2,1-7.8s0.7-5.5,1-8.2c0.4-3,0.8-6,1.1-9c0.3-2.6,0.6-5.2,0.9-7.8c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.2,0,0.3,0
                      c4.9,0,9.9,0,14.8,0c1.2,0,1.7,0.4,1.7,1.3c0.2,0.6-0.2,1.3-0.8,1.4c-0.2,0-0.4,0-0.5,0H14.1c-1,0-1.1,0.1-1.2,1.1
                      c-0.4,3-0.8,6.1-1.2,9.1c-0.3,2.6-0.6,5.1-1,7.7s-0.6,5-1,7.6s-0.7,5.3-1,7.9c-0.2,1.7-0.4,3.4-0.6,5.1C8,80.4,8,80.9,8,81.5z"/>
                    <path class="st0" d="M63.1,24.4c-0.1,4.4-0.8,8.7-2.3,12.8c-2,6.5-4.8,12.7-8.5,18.5c-1.4,2.1-3.2,4-4.8,6c-0.2,0.3-0.3,0.7-0.3,1
                      c-0.1,0.4-0.3,0.8-0.5,1.1c-0.8,0.6-1.7,1.2-2.6,1.7c-0.6,0.4-1.4,0.3-1.8-0.3c-0.1-0.1-0.1-0.2-0.1-0.2c-0.4-0.5-0.2-1.3,0.3-1.6
                      c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,1-0.6c0.7-0.3,0.4-0.6,0.1-1c-2.2-2.4-4.2-5.1-5.9-7.9c-3.5-6-6.2-12.4-8-19.2
                      c-0.7-2.6-1.2-5.3-1.5-8.1c-0.4-5.2,0.4-10.2,3.6-14.5c2-2.7,5-4.5,8.3-5.1c5-1,10.1-1,14.8,1.3c3.5,1.7,6,4.9,7,8.7
                      C62.8,19.3,63.2,21.9,63.1,24.4z M36,20.5c-0.7,1.7,2.3,11.3,8.3,11.9c6.9,0.7,11.7-7.7,11.3-9.1c-0.5-2.1-2.3-8.5-8.3-9.1
                      C41.5,13.6,36.8,18.4,36,20.5z"/>
                    <path class="st0" d="M61.1,61.4h-0.8c-0.8,0.1-1.4-0.5-1.5-1.2s0.5-1.4,1.2-1.5c0.1,0,0.1,0,0.2,0l2.4-0.2c0.8-0.2,1.6,0.3,1.8,1.1
                      c0,0.1,0,0.2,0,0.3c0.1,0.7-0.5,1.3-1.2,1.3c0,0,0,0,0,0c-0.4,0.1-0.8,0.1-1.1,0.1S61.5,61.4,61.1,61.4L61.1,61.4L61.1,61.4z"/>
                    <path class="st0" d="M76.6,52.3c-0.1,0.6-0.3,1.2-0.5,1.8c-0.2,0.6-1,1-1.6,0.7c0,0,0,0,0,0c-0.6-0.2-1-0.9-0.9-1.6
                      c0.1-0.7,0.1-1.5,0-2.2c-0.2-0.7,0.2-1.5,1-1.7c0.1,0,0.1,0,0.2,0c0.7-0.1,1.4,0.3,1.5,1c0,0,0,0.1,0,0.1
                      C76.4,50.9,76.5,51.5,76.6,52.3z"/>
                    <path class="st0" d="M21.6,76.9c-0.7-0.1-1.4-0.1-2.1-0.3c-0.7-0.2-1.1-1-0.8-1.7c0.2-0.6,0.8-1,1.4-0.9c0.9,0.1,1.7,0.1,2.6,0.1
                      c0.6-0.1,1.2,0.2,1.4,0.9c0,0.1,0,0.2,0,0.3c0.1,0.7-0.3,1.4-1.1,1.5c-0.1,0-0.2,0-0.3,0C22.4,76.8,22,76.8,21.6,76.9
                      C21.6,76.8,21.6,76.8,21.6,76.9z"/>
                    <path class="st0" d="M23.9,63.1c0.1,0.6-0.4,1.2-1,1.3c-0.1,0-0.2,0-0.3,0c-0.9,0.1-1.7,0.3-2.5,0.5c-0.5,0.2-1.1,0-1.4-0.4
                      c-0.5-0.5-0.5-1.2-0.1-1.7c1.3-0.9,2.9-1.3,4.4-1C23.6,62,24,62.5,23.9,63.1z"/>
                    <path class="st0" d="M28.5,75c-0.7,0.1-1.4-0.4-1.5-1.1c-0.2-0.6,0.2-1.3,0.8-1.4c0,0,0,0,0,0c0.9-0.4,1.9-0.8,2.8-1.2
                      c0.5-0.3,1.1-0.1,1.4,0.4c0,0,0,0,0,0c0.3,0.6,0.7,1.3,0,1.7c-1.1,0.7-2.3,1.2-3.5,1.8L28.5,75z"/>
                    <path class="st0" d="M17.4,70.6c0,1.4-0.1,1.6-1,1.8c-0.7,0.2-1.4-0.1-1.6-0.8c0-0.1,0-0.1,0-0.2c-0.2-1.2-0.1-2.4,0.3-3.6
                      c0.2-0.7,0.8-1.1,1.5-1c0.1,0,0.1,0,0.2,0.1c0.6,0.1,1.1,0.7,0.9,1.3c0,0.1,0,0.1-0.1,0.2c-0.1,0.4-0.1,0.7-0.2,1.1
                      C17.4,70,17.4,70.3,17.4,70.6z"/>
                    <path class="st0" d="M69.3,45.7c0.5,0,1,0.1,1.4,0.2c0.6,0,1.1,0.6,1.1,1.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.7-0.8,1.2-1.6,1.1
                      c-0.8,0-1.5,0-2.3,0.2c-0.7,0.2-1.4-0.1-1.7-0.8c-0.3-0.6-0.1-1.3,0.5-1.6c0.1,0,0.1-0.1,0.2-0.1C67.6,45.9,68.4,45.8,69.3,45.7
                      L69.3,45.7z"/>
                    <path class="st0" d="M54.3,59.1c0.6-0.1,1.2,0.3,1.3,0.9c0,0.1,0,0.1,0,0.2c0.2,0.6-0.1,1.2-0.7,1.4c-1.2,0.3-2.4,0.5-3.5,0.6
                      c-0.7,0-1.3-0.5-1.4-1.2c-0.1-0.7,0.4-1.3,1.1-1.3C52.1,59.4,53.3,59.3,54.3,59.1z"/>
                    <path class="st0" d="M69,60.6c-0.7,0.1-1.3-0.4-1.4-1.1c-0.1-0.7,0.3-1.3,0.9-1.4c0.9-0.4,1.9-0.8,2.8-1.2c0.6-0.2,1.2,0,1.5,0.5
                      c0.4,0.4,0.4,1,0,1.4c0,0,0,0,0,0C71.7,59.9,70.4,60.5,69,60.6z"/>
                    <path class="st0" d="M36.3,71.1c-0.6,0-1.2-0.4-1.4-1c-0.2-0.5,0-1.1,0.4-1.3c0.9-0.7,1.7-1.3,2.6-1.9c0.5-0.4,1.2-0.3,1.6,0.1
                      c0.1,0.1,0.1,0.2,0.2,0.3c0.4,0.4,0.5,1.1,0.1,1.5c-0.1,0.1-0.2,0.2-0.3,0.2c-0.9,0.7-1.8,1.3-2.7,1.8C36.7,70.9,36.5,71,36.3,71.1
                      z"/>
                    <path class="st0" d="M43.5,36c-5.9-0.1-8.4-7-8.4-12.9S40,12.5,45.9,12.6c5.9,0.1,10.6,4.9,10.5,10.8c0,0,0,0,0,0
                      C56.3,29.2,49.4,36,43.5,36z M45.6,15.3c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8c0-4.4-3.5-8-7.9-8C45.7,15.2,45.7,15.2,45.6,15.3z"
                      /></g>
                    </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Map
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_PRICING }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_PRICING)">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                       <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                        <g><path class="cls-1" d="M85.72,44a39,39,0,0,1-8.57-1.43,1.08,1.08,0,0,0-1.5.59,13.41,13.41,0,0,1-2,2.78Q56.71,63,39.73,80a7.23,7.23,0,0,1-10.5.06Q18,68.86,6.74,57.58a7,7,0,0,1,0-10.07q17-17.09,34.15-34.16a10.29,10.29,0,0,1,8.31-3c0.25,0,.52,0,0.79,0,6,0.07,11.95.12,17.93,0.21a13.58,13.58,0,0,1,2.56.25,7.63,7.63,0,0,1,6,6.59,1.12,1.12,0,0,0,.88,1.07,43.68,43.68,0,0,1,10.18,5.22c1.69,1.18,3.19,2.62,4.79,3.93a13.7,13.7,0,0,1,3.89,5.26c1.85,4.33-2.09,8.95-4.6,10.16A17.12,17.12,0,0,1,85.72,44Zm-45.3-6.72A7.11,7.11,0,0,0,34,47c0.64,1.69,1.31,3.36,1.93,5.06,0.74,2.11-.43,3.95-2.39,3.57a4.13,4.13,0,0,1-2.29-1.5,31.31,31.31,0,0,1-2.52-4.29c-0.55-1-1-1.28-2-.68-0.61.33-1.21,0.65-1.8,1a1.56,1.56,0,0,0-.72,2.22,23.44,23.44,0,0,0,1.59,2.93c0.89,1.36.89,1.74-.24,2.91s-1.19,1.4,0,2.6c1.77,1.85,2.28,1.83,3.87-.22a1.16,1.16,0,0,1,1.63-.42,12.68,12.68,0,0,0,2.5.9,6.74,6.74,0,0,0,7.4-2.81,7.87,7.87,0,0,0,.76-7.7c-0.64-1.68-1.27-3.41-1.87-5.1a1.75,1.75,0,0,1,.63-2.08,1.65,1.65,0,0,1,2-.06,6.19,6.19,0,0,1,1.73,1.38,34.08,34.08,0,0,1,2.1,3.44c0.47,0.82.77,1,1.65,0.57,0.65-.29,1.28-0.63,1.92-0.95a1.37,1.37,0,0,0,.78-2,20.58,20.58,0,0,0-1.39-2.56c-0.79-1.26-.8-1.34.24-2.41s1.08-1.42,0-2.63c-1.86-2.14-2.28-1.27-3.63,0a1.5,1.5,0,0,1-1.8.36C42.83,38,41.62,37.68,40.42,37.32Zm36.11-4.69a9.36,9.36,0,0,1-1.24-.4c-2.84-1.44-5.65-2.91-8.49-4.34A1.29,1.29,0,0,1,66,26.51a5.67,5.67,0,0,0-2-4.41,6.15,6.15,0,0,0-7-.63,5.85,5.85,0,0,0-2.93,6.18,5.54,5.54,0,0,0,3.73,4.63A5.46,5.46,0,0,0,64,31.19a0.68,0.68,0,0,1,1-.11c1,0.65,2,1.3,3,1.87a43.19,43.19,0,0,0,14.59,5,16.49,16.49,0,0,0,6.58-.07c2.22-.63,2.71-1.8,1.35-3.67a25.15,25.15,0,0,0-2.82-3.12A30.48,30.48,0,0,0,80,25.91c-1.08-.57-2.23-1-3.46-1.51v8.24Z"/><path class="cls-1" d="M42.81,85.8c0.45-.44.8-0.76,1.13-1.08Q61.28,67.34,78.66,50a1.48,1.48,0,0,1,1.11-.32c0.94,0.07,1.86.29,2.8,0.41a0.87,0.87,0,0,1,.95,1c0,9.28,0,18.53,0,27.78A7,7,0,0,1,78,85.78a5.9,5.9,0,0,1-1.37.08H43.81C43.53,85.86,43.24,85.82,42.81,85.8Z"/></g>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Pricing
                    </span>
                  </div>
              </a>
            </li>
            <li
              v-if="hasAirContract"
              class="kt-nav__item"
              :class="{ 'active': selectedTab === tabs.TAB_AIR_CONTRACT }"
            >
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_AIR_CONTRACT)">
                <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg fill="#000000" height="20" width="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                           viewBox="0 0 315.752 315.752" xml:space="preserve">
                      <g>
                        <path d="M263.89,8.743c-3.039,0-5.503,2.464-5.503,5.503v257.607c0,0.854,0.199,1.696,0.581,2.461l14.829,29.654
                          c0.932,1.864,2.837,3.042,4.922,3.042c2.084,0,3.989-1.178,4.922-3.042l14.828-29.654c0.382-0.765,0.581-1.606,0.581-2.461V14.246
                          c0-3.039-2.464-5.503-5.503-5.503H263.89z M288.044,270.552l-9.325,18.649l-9.326-18.649V19.749h18.651V270.552z"/>
                        <path d="M304.746,48.037v87.789c0,3.039,2.464,5.503,5.503,5.503c3.039,0,5.503-2.464,5.503-5.503V48.037
                          c0-3.039-2.464-5.503-5.503-5.503C307.21,42.534,304.746,44.998,304.746,48.037z"/>
                        <path d="M186.526,164.64H47.204c-3.039,0-5.503,2.465-5.503,5.504c0,3.039,2.464,5.502,5.503,5.502h139.322
                          c3.039,0,5.503-2.463,5.503-5.502C192.029,167.105,189.565,164.64,186.526,164.64z"/>
                        <path d="M186.526,246.068H47.204c-3.039,0-5.503,2.464-5.503,5.503c0,3.039,2.464,5.503,5.503,5.503h139.322
                          c3.039,0,5.503-2.464,5.503-5.503C192.029,248.532,189.565,246.068,186.526,246.068z"/>
                        <path d="M186.526,129.295H47.204c-3.039,0-5.503,2.464-5.503,5.503c0,3.039,2.464,5.503,5.503,5.503h139.322
                          c3.039,0,5.503-2.464,5.503-5.503C192.029,131.759,189.565,129.295,186.526,129.295z"/>
                        <path d="M47.204,104.959h82.709c3.039,0,5.503-2.465,5.503-5.504c0-3.039-2.464-5.502-5.503-5.502H47.204
                          c-3.039,0-5.503,2.463-5.503,5.502C41.701,102.494,44.165,104.959,47.204,104.959z"/>
                        <path d="M47.204,69.615h82.709c3.039,0,5.503-2.463,5.503-5.502c0-3.039-2.464-5.504-5.503-5.504H47.204
                          c-3.039,0-5.503,2.465-5.503,5.504C41.701,67.152,44.165,69.615,47.204,69.615z"/>
                        <path d="M5.488,306.568h222.754c3.031,0,5.488-2.457,5.488-5.488V87.843l0,0l0,0c0-0.008-0.001-0.015-0.001-0.022
                          c-0.001-0.177-0.01-0.353-0.027-0.525c-0.013-0.134-0.036-0.265-0.059-0.396c-0.008-0.045-0.012-0.091-0.02-0.136
                          c-0.031-0.154-0.071-0.308-0.115-0.459c-0.006-0.02-0.01-0.04-0.016-0.061c-0.047-0.15-0.102-0.299-0.16-0.446
                          c-0.008-0.019-0.014-0.039-0.021-0.058c-0.057-0.138-0.122-0.271-0.191-0.402c-0.014-0.027-0.025-0.057-0.04-0.084
                          c-0.064-0.119-0.136-0.234-0.208-0.349c-0.024-0.037-0.045-0.077-0.069-0.113c-0.069-0.103-0.146-0.202-0.223-0.301
                          c-0.033-0.043-0.064-0.089-0.098-0.132c-0.095-0.115-0.197-0.225-0.303-0.333c-0.02-0.021-0.036-0.043-0.057-0.063l-73.174-73.173
                          c-0.127-0.127-0.26-0.246-0.397-0.359c-0.036-0.029-0.075-0.055-0.111-0.083c-0.105-0.082-0.211-0.164-0.32-0.237
                          c-0.032-0.021-0.067-0.04-0.1-0.061c-0.118-0.076-0.238-0.15-0.361-0.217c-0.022-0.012-0.047-0.021-0.069-0.033
                          c-0.137-0.071-0.275-0.139-0.417-0.197c-0.016-0.007-0.032-0.012-0.047-0.018c-0.15-0.061-0.303-0.116-0.457-0.164
                          c-0.018-0.005-0.035-0.008-0.053-0.013c-0.153-0.046-0.309-0.086-0.467-0.118c-0.043-0.008-0.089-0.012-0.132-0.02
                          c-0.133-0.023-0.266-0.047-0.4-0.06c-0.181-0.019-0.364-0.028-0.548-0.028l0,0H5.488C2.457,9.183,0,11.64,0,14.671V301.08
                          C0,304.111,2.457,306.568,5.488,306.568z M214.995,82.357l-54.434,0.006l-0.003-54.441L214.995,82.357z M10.976,20.16h138.605
                          l0.004,67.692c0,1.456,0.578,2.852,1.607,3.881c1.029,1.028,2.426,1.606,3.881,1.606l67.682-0.008v202.261H10.976V20.16z"/>
                      </g>
                      </svg>
                    </span>
                </div>
                <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Air Contract
                    </span>
                </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_TERMS_AND_CONDITIONS }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_TERMS_AND_CONDITIONS)">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                        <g><path class="cls-1" d="M3.78,44.26V5.73c0-1.13,0-1.13,1.15-1.13H64.5c1.15,0,1.16,0,1.16,1.13,0,6.29,0,12.58,0,18.87a2.15,2.15,0,0,0,.68,1.64c2,2,4,4,6,5.93A2.05,2.05,0,0,1,73,33.71q0,28.27,0,56.5c0,0.86-.25,1-1.06,1q-29.91-.05-59.81,0c-0.81,0-1.08-.21-1-1,0.07-1.75,0-3.51,0-5.26,0-.82-0.26-1-1.05-1-1.75.07-3.51,0-5.26,0.05a0.81,0.81,0,0,1-1-1Q3.79,63.6,3.78,44.26Zm9.9,7.28V87.48c0,1.1,0,1.11,1.1,1.11H69.24c1.08,0,1.08,0,1.08-1.05q0-25.92,0-51.8c0-.83-0.22-1-1-1-6,0-12.08,0-18.12,0-1.12,0-1.12,0-1.13-1.09q0-9,0-18c0-1.17,0-1.17-1.14-1.17H14.77c-1.09,0-1.09,0-1.09,1.12V51.54ZM62.84,22.62c0.07,0,.14-0.07.21-0.09V8.46C63,7.2,63,7.2,61.84,7.2H7.6c-1.21,0-1.21,0-1.21,1.26V80.09a1.92,1.92,0,0,1,0,.4c-0.1.67,0.25,0.85,0.85,0.83a25.12,25.12,0,0,1,2.83,0c0.79,0,1.11-.25,1-1a6.72,6.72,0,0,1,0-.8V13c0-1.08,0-1.08,1-1.08q19.48,0,38.94,0a1.89,1.89,0,0,1,1.42.61q4.82,4.76,9.68,9.53C62.37,22.22,62.61,22.41,62.84,22.62Zm5.55,9.45C63.13,26.84,58,21.73,52.75,16.47c0,0.55-.05.8-0.05,1.07,0,4.53,0,9.06,0,13.58a0.82,0.82,0,0,0,1,1c4.58-.05,9.17,0,13.75,0C67.69,32.12,67.95,32.08,68.39,32.07Z"/><path class="cls-1" d="M42.09,75.51H59.81c1.15,0,1.62.4,1.63,1.31a1.14,1.14,0,0,1-1,1.27,5.36,5.36,0,0,1-1,0H24.11a1.32,1.32,0,1,1,0-2.6h18Z"/><path class="cls-1" d="M42,43.33H25c-0.3,0-.59,0-0.89,0-1,0-1.54-.44-1.55-1.26A1.34,1.34,0,0,1,24,40.72a4.1,4.1,0,0,1,.65,0q17.34,0,34.71,0a5.65,5.65,0,0,1,1.26.14,1.14,1.14,0,0,1,.76,1.41,1.06,1.06,0,0,1-1,1,5.43,5.43,0,0,1-1,0H42Z"/><path class="cls-1" d="M42.07,52.49q8.91,0,17.8,0c1.25,0,1.63.38,1.56,1.41A1,1,0,0,1,60.62,55a6.63,6.63,0,0,1-1.28.15H24.78A5.74,5.74,0,0,1,23.66,55a1.19,1.19,0,0,1-1.09-1.33,1.16,1.16,0,0,1,1.3-1.14c2.89,0,5.77,0,8.66,0h9.54Z"/><path class="cls-1" d="M42.08,64H59.31a6.33,6.33,0,0,1,1.14.06,1,1,0,0,1,1,1,1.13,1.13,0,0,1-.76,1.41,4.85,4.85,0,0,1-1.11.15h-35c-1.23,0-1.69-.23-1.89-1A1.19,1.19,0,0,1,23.72,64a8.27,8.27,0,0,1,1,0H42.08Z"/><path class="cls-1" d="M31.08,31.81h-7c-1,0-1.51-.41-1.55-1.22a1.3,1.3,0,0,1,1.55-1.36q7.06,0,14.15,0a1.3,1.3,0,1,1,.08,2.57C35.92,31.83,33.5,31.81,31.08,31.81Z"/></g>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Terms &amp; conditions
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_BOOK_MY_GROUP }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_BOOK_MY_GROUP)">
                   <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.09 120">
                        <g><path class="cls-1" d="M6.44,47.76V6.26c0-1.13,0-1.13,1.15-1.13q23.93,0,47.87,0a1.83,1.83,0,0,1,1.56.7c3.31,4,6.63,7.87,10,11.8,2.74,3.25,5.49,6.48,8.2,9.74a1.94,1.94,0,0,1,.42,1.13q0,30.52,0,61a0.73,0.73,0,0,1-.91.9q-33.69,0-67.39,0c-0.79,0-.91-0.32-0.91-1Q6.45,68.59,6.44,47.76Zm65.94-17.6H71.24c-5.33,0-10.67,0-16,0a0.8,0.8,0,0,1-1-1c0-6.63,0-13.27,0-19.9,0-1.08,0-1.08-1.1-1.08H10.78c-1.11,0-1.11,0-1.11,1.09V86.15c0,1,0,1,1,1H72.38v-57Zm-2-3.44L57.28,11.07a5.41,5.41,0,0,0-.1.69c0,4.75,0,9.51,0,14.25a0.68,0.68,0,0,0,.85.81c3.85,0,7.7,0,11.55,0C69.76,26.8,70,26.76,70.35,26.72Z"/><path class="cls-1" d="M29.4,63c2.14,3.5,4.23,6.93,6.41,10.5L56,53.46,58.3,55.4l-23,23.34c-2.85-4.77-5.66-9.46-8.5-14.22Z"/><path class="cls-1" d="M31.57,42.91c-4.9,0-9.82,0-14.72,0a0.8,0.8,0,0,1-1-1c0-2.08,0-2.08,2.1-2.08H46.38c1,0,1,0,1,1.05,0,2,0,2-2,2H31.57Z"/><path class="cls-1" d="M29.18,20.88c4.09,0,8.17,0,12.26,0a0.74,0.74,0,0,1,.92.89c0,2.35,0,2.35-2.31,2.35-7.72,0-15.44,0-23.15,0-0.79,0-1.14-.17-1-1a6.51,6.51,0,0,0,0-1.42c-0.06-.64.21-0.82,0.83-0.82C20.86,20.89,25,20.88,29.18,20.88Z"/><path class="cls-1" d="M28,33.67c-3.73,0-7.48,0-11.21,0a0.73,0.73,0,0,1-.89-0.92c0-2.3,0-2.3,2.28-2.3,7,0,14,0,21,0a0.8,0.8,0,0,1,1,1c0,2.21,0,2.22-2.2,2.22H28Z"/></g>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Book my group
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_CONSUMER_SECTION }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_CONSUMER_SECTION)">
                   <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" viewBox="0 0 54 54">
                        <path class="st0" d="M47.7 30.5c-.4.1-.9.3-1.3.3s-.6.1-.7.5c-1 3.7-2 7.5-3 11.2-.3 1.3-.7 2.6-1.1 3.9-.5 1.6-1.8 2.6-3.4 2.6H16c-1.7 0-3-1-3.4-2.6-1.1-4.1-2.2-8.1-3.3-12.2-.3-1-.5-2-.8-3-.1-.3-.2-.4-.5-.3h-.5c-.8 0-1.4-.6-1.4-1.4v-2.1c0-.9.6-1.4 1.5-1.4h6.3v-.8-7.4c0-2.2 1.4-3.7 3.7-3.7h1.2v-1.2c0-.3.1-.6.3-.8.5-.6 1-1.1 1.6-1.6.1-.1.2-.4.2-.5V8c0-.6.2-.8.8-.8h11.5c.8-.2 1 .1 1 .8v6.1h2.4c.6 0 1.3.1 1.8.3 1.4.6 2.1 1.7 2.1 3.2v8.3h5.7c.5 0 1 .2 1.5.3v4.3zm-3.2.3H10l.3 1.2c1.2 4.6 2.5 9.2 3.7 13.8.3 1.2 1 1.8 2.3 1.8h21.9c.2 0 .5 0 .7-.1.9-.3 1.4-.9 1.6-1.8 1-3.7 2-7.5 3-11.2.3-1.3.6-2.4 1-3.7zM34.3 18.3c0 .1-.1.1-.1.2-.4 1.7-1.8 2.3-3.3 1.5-.1-.1-.4 0-.5 0-.7.4-1.5.4-2.2 0-.3-.2-.4-.1-.6 0-.7.4-1.5.4-2.2 0-.3-.2-.4-.1-.6 0-1.2.7-2.6.2-3.1-1.1-.1-.2-.1-.4-.1-.6h-3.4v7.6h18.1v-7.6h-2zm-2.9-2.1v2.1c0 .4.3.7.7.7.4 0 .6-.3.7-.7V18 9.6v-1H22.3v.5c.2 1.3-.2 2.3-1.3 3.1l-.3.3c-.6.4-.5 1-.4 1.6h1.8c.7 0 .9.2.9.9v3.1c0 .4.2.7.6.8.4.1.8-.3.8-.8v-2h1.4v2.1c0 .4.3.7.7.7.4 0 .7-.2.7-.6v-.6-1.5h1.4v1.9c0 .5.3.9.7.9.4 0 .7-.3.7-.9v-1.9h1.4zM7.7 29.4h39v-2h-39v2zm9-3.5v-.5-7.6c0-.7.2-.9.9-.9h3.9v-1.3h-4c-1.3 0-2.2.9-2.2 2.2V26c.5-.1 1-.1 1.4-.1zm22.3 0v-.1-8.3c0-1-.7-1.9-1.7-2-1-.1-2.1 0-3.1 0v1.3h2.4c.8 0 1 .2 1 1v8c.6.1 1 .1 1.4.1z"/><path class="st0" d="M27.3 36.5c.2-.2.3-.4.5-.6 1.2-1.2 2.9-1.3 4.2-.1 1.2 1.1 1.3 3.1.2 4.3-1.4 1.5-2.8 2.9-4.2 4.4-.4.4-.8.4-1.2 0-1.4-1.4-2.8-2.9-4.2-4.3-1.1-1.2-1-3.2.1-4.3 1.2-1.2 2.9-1.1 4.2.1 0 .1.1.3.4.5zm-.2 6.4c.9-.8 1.8-1.6 2.6-2.4.5-.4.9-.9 1.3-1.4.6-.7.6-1.7-.1-2.3-.6-.6-1.5-.6-2.2.1l-.9.9c-.4.4-.8.4-1.1 0-.3-.3-.6-.7-.9-1-.7-.6-1.5-.7-2.1-.1-.6.6-.8 1.6-.2 2.2 1.1 1.5 2.4 2.8 3.6 4zM20.9 42v2H23v1.4h-2.9c-.2 0-.5-.4-.5-.6-.1-.9 0-1.8 0-2.8h1.3zM34.2 34.3h-2.1v-1.4H35c.2 0 .5.4.6.6.1.9 0 1.9 0 2.8h-1.4v-2zM13.9 33.6h-1.4v-1.3h1.4v1.3zM16.7 32.2v1.3h-1.3v-1.3h1.3zM18.2 33.6v-1.3h1.3v1.3h-1.3z"/>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text d-flex align-items-center">
                      Sales Flyer
                      <!--<span
                        class="kt-badge kt-badge--beta kt-badge--inline kt-badge--pill kt-badge--rounded ml-3"
                        v-tooltip.right-end="{ content: 'Software in the beta phase will generally have many more bugs in it than completed software, speed or performance issues, and may still cause crashes or data loss. Please not use for commercial purpose.', offset: 5 }"
                        v-if="false">Beta
                      </span>-->
                    </span>
                  </div>
              </a>
            </li>
            <li class="kt-nav__item" :class="{ 'active': selectedTab === tabs.TAB_GUEST_DOCUMENTATION }">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_GUEST_DOCUMENTATION)">
                   <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                      <svg class="iconNavItinerary" viewBox="0 0 54 54">
                        <path class="st0" d="M36.3 26c.1-4.9-2.3-8.1-6.7-10.1 1-.9 1.6-2.2 1.5-3.6-.1-1.3-.6-2.4-1.5-3.2-1.9-1.5-4.4-1.5-6.1.2-1.6 1.6-2 4.4.1 6.5-4.4 1.9-6.7 5.1-6.7 10.1H7.4c-1.5 0-2.6.6-3.4 1.9-.4.6-.5 1.3-.5 2V46c0 1.1.3 2.1 1.1 2.8.6.8 1.5 1.2 2.6 1.2h38.9c1.4 0 2.5-.6 3.2-1.7.4-.5.6-1.3.6-1.9 0-5.5.1-11.1 0-16.6 0-1.4-.7-2.6-2.1-3.3-.7-.3-1.4-.5-2.1-.5h-9.4zM10.9 45.5V30.6h7c.1 0 .4 0 .4.1.2.4.4.9.5 1.4h-6.5V44h14.9V32.1H24.5c-.1 0-.3 0-.3-.1-.2-.5-.4-.9-.5-1.4h15.5v14.9H10.9zm11.6-18h19.8v20.9H7.1c-1.2 0-2.3-1-2.2-2.2.1-1.1 0-2.3 0-3.4v-.4h.6c1.3.1 2.4-1 2.4-2.3-.1-1.5-.1-2.9 0-4.4 0-.9-.8-2.1-1.7-2.2-.4-.1-.8-.1-1.2-.2v-3.6c-.1-1.3 1.1-2.3 2.4-2.3h9.9c.2.5.3 1 .5 1.5h-6.7c-.8 0-1.6.8-1.6 1.6.1 1.3 0 2.5 0 3.8v11.1c0 .2.1.5.2.7.4.6.9.9 1.6.9h28c.4 0 .8-.2 1.1-.4.5-.4.5-.9.5-1.4V30.6c0-.8-.8-1.6-1.6-1.6H23.6c-.1 0-.3 0-.4-.1-.3-.4-.5-.9-.7-1.4zm12.4-1.6h-2.3v-3.7h-1.4V25.4c0 .4-.1.5-.5.5h-8.3l.6-3.6-1.5-.3c-.2 1.1-.3 2.2-.5 3.2 0 .1-.1.2-.1.4-.1.5-.3 1 0 1.6.3.6.5 1.3.8 1.9.3.6.6 1.2.8 1.8.2.5.6 1 .5 1.7-.1.3-.4.7-.8.8-.5 0-.9-.1-1.1-.5-.4-1.1-.8-2.1-1.3-3.2-.1-.3-.3-.7-.4-1-.2-.6-.6-1.3-.7-1.9-.4-1.9-.1-3.7.8-5.4.6-1.2 1.5-2.2 2.6-3 1.1-.8 2.4-1.3 3.8-1.4 1.4-.1 2.7 0 4 .6.8.4 1.6.8 2.2 1.4.7.6 1.3 1.3 1.7 2.2.3.5.5 1.1.7 1.6.3 1.1.4 2.1.4 3.1zm-9 16.5h-12v-9h5.3c.1 0 .3.1.4.2.2.4.6.7 1 1 1.1.6 2.4.3 3.1-.6.4-.5.7-.8 1.4-.7h.3c.5 0 .5 0 .5.5v8.6zm17.9 6V27.5h2.1c1.4 0 2.4 1 2.4 2.4v16c0 .4-.1.8-.2 1.2-.2.7-.8 1.2-1.5 1.3h-2.8zM26.6 15.5c-1.5 0-2.9-1.3-3-2.9-.1-1.8 1.3-3.1 2.9-3.1 1.7 0 3 1.3 3 2.8.2 1.8-1.2 3.2-2.9 3.2zM5 35h.7c.4 0 .7.3.7.7v4.6c0 .3-.2.6-.5.6H5V35z"/><path class="st0" d="M28.8 42.5h9v-1.3c0-.1-.2-.2-.3-.2h-8.2c-.3 0-.4.1-.4.4-.1.3-.1.6-.1 1.1zM28.8 35v1.4h9V35h-9zM28.8 32.1v1.4h9v-1.4h-9zM31.9 38v1.5h5.9V38h-5.9zM28.8 38v1.5h1.5V38h-1.5zM46.8 35h-1.5v5.9h1.5V35z"/>
                      </svg>
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text d-flex align-items-center">
                      Guest Documentation
                      <!--<span
                        class="kt-badge kt-badge--beta kt-badge--inline kt-badge--pill kt-badge--rounded ml-3"
                        v-tooltip.right-end="{ content: 'Software in the beta phase will generally have many more bugs in it than completed software, speed or performance issues, and may still cause crashes or data loss. Please not use for commercial purpose.', offset: 5 }"
                        v-if="true">Beta
                      </span>-->
                    </span>
                  </div>
              </a>
            </li>
            <li
              v-if="hasExtensions"
              class="kt-nav__item"
              :class="{ 'active': selectedTab === tabs.TAB_EXTENSIONS, 'kt-nav__item--disabled': isShareDisabled }"
            >
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_EXTENSIONS, 'body')">
                <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>ferry</title><path d="M6,6H18V9.96L12,8L6,9.96M3.94,19H4C5.6,19 7,18.12 8,17C9,18.12 10.4,19 12,19C13.6,19 15,18.12 16,17C17,18.12 18.4,19 20,19H20.05L21.95,12.31C22.03,12.06 22,11.78 21.89,11.54C21.76,11.3 21.55,11.12 21.29,11.04L20,10.62V6C20,4.89 19.1,4 18,4H15V1H9V4H6A2,2 0 0,0 4,6V10.62L2.71,11.04C2.45,11.12 2.24,11.3 2.11,11.54C2,11.78 1.97,12.06 2.05,12.31M20,21C18.61,21 17.22,20.53 16,19.67C13.56,21.38 10.44,21.38 8,19.67C6.78,20.53 5.39,21 4,21H2V23H4C5.37,23 6.74,22.65 8,22C10.5,23.3 13.5,23.3 16,22C17.26,22.65 18.62,23 20,23H22V21H20Z" /></svg>
                    </span>
                </div>
                <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Extensions
                    </span>
                </div>
              </a>
            </li>
            <li
              class="kt-nav__item"
              :class="{ 'active': selectedTab === tabs.TAB_SHARE, 'kt-nav__item--disabled': isShareDisabled }"
              v-if="!isShareDisabled">
              <a
                class="kt-nav__link select-none"
                data-toggle="tab"
                href=""
                role="tab"
                @click.prevent="selectTab(tabs.TAB_SHARE, 'body')">
                  <div class="col-sm-2 col-12">
                    <span class="kt-nav__link-text">
                       <font-awesome-icon class="iconNavItinerary ml-1" :icon="['fas', 'share-alt']" />
                    </span>
                  </div>
                  <div class="col-sm-10 p-0 pl-3 hide-mobile-ttc">
                    <span class="kt-nav__link-text">
                      Download
                    </span>
                  </div>
              </a>
            </li>
          </ul>

        </div>
        <div class="col-10 px-1 zoomInDown animated py-4" :class="{ 'bg-light': isReorderingItinerary }">
          <div class="tab-content">

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_DETAILS">
              <TabDetails
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote"
                :save="save"
                 :key="componentKey" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_LETTER">
              <TabLetter
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_ITINERARY">
              <BaseContentLoader :data="{ type: 'itinerary-day', count: 3 }" v-if="!opportunityData" />
              <TabItinerary
                v-else
                :isCompletedQuote="isCompletedQuote"
                @onSelectTab="onTabItinerarySelectTab" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_INCLUDED">
              <TabIncluded
                v-if="opportunityData && opportunityData.itineraries"
                dataRootKey="itineraries"
                :stages="['Highlights', 'Included', 'Not Included']"
                :data="opportunityData.itineraries"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="true" v-if="selectedTab === tabs.TAB_MAP">
              <SourceTypeNavigation
                v-if="isVisibleSourceTypeNav"
                :sourceTypes="sourceTypes"
                :itinerarySourceTypeSelected="itinerarySourceTypeSelected"
                @onSelectTab="selectTabSourceTypeNav"
                v-show="false" />
              <img
                v-if="mapImage"
                :src="mapImage"
                alt="Map Image"
                style="width: 100%; height: 60vh; object-fit: contain;"
              >
              <TabMap v-else :key="componentKey" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_PRICING">
              <TabPricing
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote"
                @onSaveEnabled="priceSaveEnabled = $event"
              />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_AIR_CONTRACT">
              <TabAirContract
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_TERMS_AND_CONDITIONS">
              <TabTermsAndConditions
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_BOOK_MY_GROUP">
              <TabBookMyGroup
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote"
                :data="opportunityData" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_CONSUMER_SECTION">
              <TabConsumerSection
                v-if="consumerSectionData"
                :data="consumerSectionData"
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote"
                :isImporting="isImporting"
                @import="importInclusions" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_GUEST_DOCUMENTATION">
              <TabGuestDocumentation
                v-if="guestDocumentationData"
                :data="guestDocumentationData"
                :validationGroupName="validationGroupName"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_EXTENSIONS">
              <TabExtensions
                v-if="opportunityData"
                ref="childExtension"
                :data="opportunityData"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>

            <TabbedPortletBodyTab :show="selectedTab === tabs.TAB_SHARE">
              <TabShare
                v-if="opportunityData"
                :data="opportunityData"
                :isCompletedQuote="isCompletedQuote" />
            </TabbedPortletBodyTab>
          </div>
        </div>
      </div>

      <div id="opportunity-edit-json" style="display: none;" v-if="opportunityData"></div>

    </TabbedPortletBody>

    <TabbedPortletFoot>
      <template v-slot:rightButtons>
        <BaseButton
          type="submit"
          classButton="btn btn-icon-box btn-primary btn-labeled"
          @click="save()"
          :disabled="isSaving || isLoadingCompleteQuote || !isActiveSaveButton ">
          <span v-if="!isSaving && isActiveSaveButton">SAVE <span class="btn-label"><font-awesome-icon :icon="['fas', 'check']"/></span></span>
          <span v-if="!isActiveSaveButton">Viewing<span class="btn-label"><font-awesome-icon :icon="['fas', 'eye']"/></span></span>
          <span v-if="isSaving"><font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" /></span>
        </BaseButton>
      </template>
    </TabbedPortletFoot>

  </TabbedPortletOpportunity>
</template>

<script>
import { mapGetters } from 'vuex'
import messageTypes from '@/store/messages/types'
import NProgress from 'nprogress'

import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletFoot from '@/components/_shared/tabbed-portlet/TabbedPortletFoot.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import TabDetails from '@/components/opportunity-edit/TabDetails.vue'
import TabLetter from '@/components/opportunity-edit/TabLetter.vue'
import TabItinerary from '@/components/opportunity-edit/TabItinerary.vue'
import TabMap from '@/components/opportunity-edit/TabMap.vue'
import TabPricing from '@/components/opportunity-edit/TabPricing.vue'
import TabTermsAndConditions from '@/components/opportunity-edit/TabTermsAndConditions.vue'
import TabBookMyGroup from '@/components/opportunity-edit/TabBookMyGroup.vue'
import TabConsumerSection from './tab-consumer-section/TabConsumerSection.vue'
import TabGuestDocumentation from './tab-guest-documentation/TabGuestDocumentation.vue'
import TabShare from '@/components/opportunity-edit/TabShare.vue'
import TabIncluded from '@/components/opportunity-edit/TabIncluded.vue'
import SourceTypeNavigation from '@/components/opportunity-edit/SourceTypeNavigation.vue'
import TabAirContract from "@/components/opportunity-edit/TabAirContract.vue";
import {OPPORTUNITY__BRANDS} from "@/constants";
import TabExtensions from "@/components/opportunity-edit/TabExtensions.vue";

export default {
  name: 'OpportunityEdit',
  inject: ['$v'],
  components: {
    TabExtensions,
    TabAirContract,
    TabbedPortletOpportunity,
    TabbedPortletBody,
    TabbedPortletFoot,
    TabbedPortletBodyTab,
    TabDetails,
    TabLetter,
    TabItinerary,
    TabMap,
    TabPricing,
    TabTermsAndConditions,
    TabBookMyGroup,
    TabConsumerSection,
    TabGuestDocumentation,
    TabShare,
    TabIncluded,
    SourceTypeNavigation
  },
  beforeRouteLeave (to, from, next) {
    const uuid = this.$route.params.privateId
    const existsData = this.validateIfExistsDataInLocalStorage()
    if (existsData) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        localStorage.removeItem(uuid)
        next()
      } else {
        document.querySelector('#portletFoot').classList.toggle('sticky-bottom')
        document.querySelector('#portletFoot button').classList.toggle('invisible')
      }
    } else {
      localStorage.removeItem(uuid)
      next()
    }
  },
  data () {
    const TAB_DETAILS = 'tab_details'
    const TAB_LETTER = 'tab_letter'
    const TAB_ITINERARY = 'tab_itinerary'
    const TAB_MAP = 'tab_map'
    const TAB_PRICING = 'tab_pricing'
    const TAB_AIR_CONTRACT = 'tab_air_contract'
    const TAB_TERMS_AND_CONDITIONS = 'tab_terms_and_conditions'
    const TAB_BOOK_MY_GROUP = 'tab_book_my_group'
    const TAB_CONSUMER_SECTION = 'tab_consumer_section'
    const TAB_SHARE = 'tab_share'
    const TAB_EXTENSIONS = 'tab_extensions'
    const TAB_INCLUDED = 'tab_included'
    const TAB_GUEST_DOCUMENTATION = 'guest_documentation'

    const VALIDATION_GROUP_NAME = 'editOpportunity'

    return {
      validationGroupName: VALIDATION_GROUP_NAME,
      selectedTab: TAB_ITINERARY,
      tabs: {
        TAB_DETAILS,
        TAB_LETTER,
        TAB_ITINERARY,
        TAB_MAP,
        TAB_PRICING,
        TAB_AIR_CONTRACT,
        TAB_TERMS_AND_CONDITIONS,
        TAB_BOOK_MY_GROUP,
        TAB_CONSUMER_SECTION,
        TAB_SHARE,
        TAB_EXTENSIONS,
        TAB_INCLUDED,
        TAB_GUEST_DOCUMENTATION
      },
      isSaving: false,
      isImporting: false,
      isEditingTitle: false,
      priceSaveEnabled: false,
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters({
      'opportunityData': 'opportunity/opportunity',
      'opportunitySource': 'opportunity/opportunitySource',
      'opportunityDetails': 'opportunity/opportunityDetails',
      'isReorderingItinerary': 'opportunity/isReorderingItinerary',
      'permissions': 'opportunity/permissions',
      'getMessage': 'messages/getMessage',
      'sourceTypes': 'opportunity/sourceTypes',
      'getItinerarySourceTypeById': 'opportunity/getItinerarySourceTypeById',
      'itinerarySourceTypeSelected': 'opportunity/itinerarySourceTypeSelected',
      'existItineraryBySourceType': 'opportunity/existItineraryBySourceType',
      'getItinerariesNumber': 'opportunity/getItinerariesNumber'
    }),
    isTrafalgarRiver() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR_RIVER === this.opportunityData.properties_opportunity.id_brand
      );
    },
    mapImage() {
      if (!this.isTrafalgarRiver) return null;

      const itinerary = this.opportunitySource.itineraries[this.itinerarySourceTypeSelected.index];
      const image = itinerary.images.find((image) => image.type === 'map');
      return image ? image.image_url : null;
    },
    hasAirContract() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR === this.opportunityData.properties_opportunity.id_brand
      );
    },
    hasExtensions() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR_RIVER === this.opportunityData.properties_opportunity.id_brand
      );
    },
    consumerSectionData  () {
      if (this.opportunityData && this.opportunityData.consumer_section) {
        return this.opportunityData.consumer_section
      }
      return false
    },
    guestDocumentationData  () {
      const guestDocumentationDefault = {
        id: null,
        introduction: '',
        optional_experience: '',
        hotel_list: ''
      }
      if (this.opportunityData && this.opportunityData.guest_documentation) {
        return this.opportunityData.guest_documentation
      }
      return guestDocumentationDefault
    },
    isLoading () {
      if (this.opportunityData) {
        return true
      }
      return false
    },
    isLoadingCompleteQuote () {
      return this.getMessage(messageTypes.isLoadingCompleteQuote).value
    },
    isShareDisabled () {
      if (
        this.permissions &&
        this.permissions.share &&
        this.permissions.share === 'disabled') {
        return true
      }
      return false
    },
    isGuestDocumentationTabSelected () {
      return this.selectedTab === this.tabs.TAB_GUEST_DOCUMENTATION
    },
    isCompletedQuote () {
      if (this.isSelectedTab(this.tabs.TAB_CONSUMER_SECTION)) {
        return false
      }
      if (
        this.opportunityData &&
        this.opportunityData.permissions &&
        this.opportunityData.permissions.edit === true) {
        return false
      }
      return true
    },
    isActiveSaveButton () {
      if (this.priceSaveEnabled) return true;

      let result = false
      if (!this.isCompletedQuote) {
        result = true
      }
      if (this.isGuestDocumentationTabSelected) {
        result = true
      }
      if (this.isCompletedQuote && (this.itinerarySourceTypeSelected.text === this.getItinerarySourceTypeById('ITP-FLYER').text || this.itinerarySourceTypeSelected.text === this.getItinerarySourceTypeById('ITP-GUEST').text)) {
        result = true
      }
      return result
    },
    exportType () {
      if (this.opportunityData && this.opportunityDetails) {
        const exportTypeId = this.opportunityData.properties_opportunity.id_opportunity_export_type
        const exportTypesValues = this.opportunityDetails.types
        if (Array.isArray(exportTypesValues) && exportTypesValues.length > 0) {
          const exportTypeObject = exportTypesValues.find(type => type.value === exportTypeId)
          return exportTypeObject.text
        }
      }
      return ''
    },
    hasSupplier () {
      const editOpportunity = this.$v.editOpportunity.$model
      if (Number(editOpportunity.quoteRequestTab.supplierId) > 0) {
        return true
      }
      return false
    },
    isASalesQuoteSent () {
      const SALES_QUOTE_SENT = 23
      const editOpportunity = this.$v.editOpportunity.$model
      if (Number(editOpportunity.quoteRequestTab.stageId) === SALES_QUOTE_SENT) {
        return true
      }
      return false
    },
    isASalesAwaitingSupplier () {
      const SALES_AWAITING_SUPPLIER = 20
      const editOpportunity = this.$v.editOpportunity.$model
      if (Number(editOpportunity.quoteRequestTab.stageId) === SALES_AWAITING_SUPPLIER) {
        return true
      }
      return false
    },
    isADraft () {
      const editOpportunity = this.$v.editOpportunity.$model
      if (editOpportunity.opportunityDetailsTab.referenceNumber === '') {
        return true
      }
      return false
    },
    isVisibleSourceTypeNav () {
      return this.getItinerariesNumber > 1
    }
  },
  methods: {
    importInclusions () {
      this.$store.commit('opportunity/TEMP_IMPORT_INCLUSIONS_TO_TRIP_INCLUSIONS')
      this.save(false, true) // importing = true
    },
    isSelectedTab (tabName) {
      return this.selectedTab === tabName
    },
    printPage () {
      window.print()
    },
    toggleTitle () {
      if (!this.isCompletedQuote) {
        this.isEditingTitle = !this.isEditingTitle
        this.$refs.editingTitle.$el.focus()
      }
    },
    saveEditingTitle () {
      this.saveToLocalStorage()
      this.toggleTitle()
    },
    selectTab (tabName, scrollToEl = 'body') {
      if (this.isShareDisabled) {
        return false
      }
      this.selectedTab = tabName
      if (tabName === this.tabs.TAB_DETAILS) {
        this.forceRerender()
      }
      if (scrollTo) {
        this.$scrollTo(scrollToEl, { duration: 800, offset: 100 })
      }
    },
    selectTabSourceTypeNav (sourceType) {
      const indexItinerary = this.existItineraryBySourceType(sourceType.value)
      this.$store.commit('opportunity/SET_SOURCE_TYPE_SELECTED', { sourceType, indexItinerary })
      this.forceRerender()
    },
    validTab () {
      if (this.$v.editOpportunity.opportunityDetailsTab.$error) {
        return this.selectTab(this.tabs.TAB_DETAILS)
      }
      if (this.$v.editOpportunity.clientInformationTab.$error) {
        return this.selectTab(this.tabs.TAB_DETAILS)
      }
      if (this.$v.editOpportunity.quoteRequestTab.$error) {
        return this.selectTab(this.tabs.TAB_DETAILS)
      }
    },
    isStage (stageId) {
      const editOpportunity = this.$v.editOpportunity.$model
      if (Number(editOpportunity.quoteRequestTab.stageId) === stageId) {
        return true
      }
      return false
    },
    async save (showNotification, modeImport = false, onFinish = () => {}) {
      if (this.selectedTab === this.tabs.TAB_EXTENSIONS) {
        this.isSaving = true
        await this.$refs.childExtension.saveExtensions(() => {
          this.isSaving = false
        });
        return;
      }

      // "touching" all fields to turn them "dirty"
      this.$v.$touch()
      this.validTab()

      if (!this.hasSupplier) {
        const SALES_AWAITING_SUPPLIER = 20
        const SUPPLIER_IN_PROGRESS = 21
        const SUPPLIER_DONE = 22
        if (
          this.isStage(SALES_AWAITING_SUPPLIER) ||
          this.isStage(SUPPLIER_IN_PROGRESS) ||
          this.isStage(SUPPLIER_DONE)) {
          this.$notification.warning('Please before you continue go into <em>Details > Quote Request form</em> and select a <strong>Supplier</strong>.', 10000, true)
          return false
        }
      }

      if (this.isASalesAwaitingSupplier && this.isADraft) {
        this.$notification.warning('Please before change the stage add the corresponding "Reference number" inside the option "Details"', 10000)
        return false
      }

      if (this.isASalesQuoteSent && this.isADraft) {
        this.$notification.warning('Please before complete the opportunity you need to add the corresponding "Reference number" inside the option "Details".', 10000)
        return false
      }

      // submit form only when all fields are valid
      if (!this.$v.$invalid) {
        const editOpportunity = this.$v.editOpportunity.$model
        NProgress.start()
        this.isSaving = true
        if (modeImport) {
          this.isImporting = true
        }

        this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_DETAILS', editOpportunity)
        this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_CONSUMER_SECTION', editOpportunity)
        this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_GUEST_DOCUMENTATION', editOpportunity)

        this.$store
          .dispatch('opportunity/saveOpportunity')
          .then((response) => {
            if (response.stateUpdated) {
              this.isSearching = false
              this.isNotFound = true
              this.isSaving = false
              if (modeImport) {
                this.isImporting = false
              }
              NProgress.done()
              this.$notification.success('Changes saved successfully!')
              return false
            }
            if (response.data.status === false) {
              this.isSearching = false
              this.isNotFound = true
              this.isSaving = false
              if (modeImport) {
                this.isImporting = false
              }
              NProgress.done()
              const newMessage = 'Reference Number is in use, to continue please start again with a new Reference Number.'
              this.$notification.error(`${response.data.message}. ${newMessage}`)
              return false
            }
            if (response.data && response.data.uuidOpportunity) {
              const privateId = response.data.uuidOpportunity
              this.$notification.success(response.message)
              this.isSaving = false
              if (modeImport) {
                this.isImporting = false
              }
              if (!response.opportunity) {
                this.$store
                  .dispatch('opportunity/getOpportunity', privateId)
                  .then((response) => {
                    onFinish();
                    NProgress.done()
                  })
                  .catch(error => {
                    if (error.response && error.response.status > 400) { // 401 || 403
                      // this.$store.dispatch('auth/removeToken')
                    }
                  })
              } else {
                NProgress.done();
              }
            } else {
              this.isSearching = false
              this.isNotFound = true
              this.isSaving = false
              this.isImporting = false
              NProgress.done()
              this.$notification.error(response.message)
            }
          })
          .catch(error => {
            console.log(error)
            this.isSearching = false
            this.isNotFound = true
            this.isSaving = false
            NProgress.done()
          })

        if (showNotification) {
          this.$notification.success('Changes saved successfully!')
        }
      }
    },
    async saveToLocalStorage (showNotification, modeImport = false) {
      try {
      // "touching" all fields to turn them "dirty"
        this.$v.$touch()
        this.validTab()

        if (!this.hasSupplier) {
          const SALES_AWAITING_SUPPLIER = 20
          const SUPPLIER_IN_PROGRESS = 21
          const SUPPLIER_DONE = 22
          if (
            this.isStage(SALES_AWAITING_SUPPLIER) ||
          this.isStage(SUPPLIER_IN_PROGRESS) ||
          this.isStage(SUPPLIER_DONE)) {
            this.$notification.warning('Please before you continue go into <em>Details > Quote Request form</em> and select a <strong>Supplier</strong>.', 10000, true)
            return false
          }
        }

        if (this.isASalesAwaitingSupplier && this.isADraft) {
          this.$notification.warning('Please before change the stage add the corresponding "Reference number" inside the option "Details"', 10000)
          return false
        }

        if (this.isASalesQuoteSent && this.isADraft) {
          this.$notification.warning('Please before complete the opportunity you need to add the corresponding "Reference number" inside the option "Details".', 10000)
          return false
        }

        // submit form only when all fields are valid
        if (!this.$v.$invalid) {
          const editOpportunity = this.$v.editOpportunity.$model
          NProgress.start()
          this.isSaving = true
          if (modeImport) {
            this.isImporting = true
          }

          this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_DETAILS', editOpportunity)
          this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_CONSUMER_SECTION', editOpportunity)
          this.$store.commit('opportunity/TMP_SAVE_OPPORTUNITY_GUEST_DOCUMENTATION', editOpportunity)

          const uuid = this.$route.params.privateId
          const response = await this.$store
            .dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)
          if (response) {
            this.$notification.success('Title was saved temporarily, when you finish editing the whole itinerary, please click the "Save" button located at the bottom.')
            this.isSaving = false
            if (modeImport) {
              this.isImporting = false
            }
            NProgress.done()
          } else {
            throw new Error('Ups! something went wrong, please try again')
          }
          if (showNotification) {
            this.$notification.success('Changes saved successfully!')
          }
        }
      } catch (error) {
        console.info(error)
        this.isSearching = false
        this.isNotFound = true
        this.isSaving = false
        NProgress.done()
        this.$notification.error(error)
      }
    },
    suggestImages () {
      // NProgress.start()

      // this.isSaving = true
      const privateId = this.$route.params.privateId
      this.$store.dispatch('opportunity/suggestImages', privateId)

        .then((response) => {
          if (response && response.status === true) {
            // this.$notification.success(response.message)
            this.$store
              .dispatch('opportunity/getOpportunity', privateId)
              .then((response) => {
              // this.isSaving = false
              // NProgress.done()
              })
              .catch(error => {
                if (error.response && error.response.status > 400) { // 401 || 403
                  // this.$store.dispatch('auth/removeToken')
                }
              })
          } else {
            this.$notification.warning(response.message)
          // this.isSaving = false
          // NProgress.done()
          }
        })
        .catch(error => {
          console.log(error)
          this.isSaving = false
          NProgress.done()
        })
    },
    onTabItinerarySelectTab (tabName) {
      this.selectTab(tabName)
    },
    forceRerender () {
      this.componentKey += 1
    },
    preventReload (event) {
      const existsData = this.validateIfExistsDataInLocalStorage()
      if (!existsData) return
      event.preventDefault()
      event.returnValue = ''
    },
    validateIfExistsDataInLocalStorage () {
      const uuid = this.$route.params.privateId
      const opportunityFromLocalStorage = JSON.parse(localStorage.getItem(uuid))
      return !!opportunityFromLocalStorage
    }
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventReload)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventReload)
    })
  },
  mounted () {
    const uuid = this.$route.params.privateId
    localStorage.removeItem(uuid)
  }
  // beforeMount: async function () {
  //   await this.suggestImages()
  // }
}
</script>

<style lang="scss" scoped>
.sticky-menu {
  position: sticky !important;
  top: 71px;
}
.active .kt-nav__link-text {
  color: #00a7cb !important;
  fill: #00a7cb !important;
}
.OpportunityEdit{
      margin-left: -12.5px;
}
.OpportunityEdit-title {
  transition: all 0.6s ease-out;
  padding: 3px 10px;
  border: 1px solid rgba(255, 255, 255, 0);
  font-size: 1.7rem;
  font-weight: 600;
  cursor:pointer;
}
.OpportunityEdit-title:hover {
  border: 1px solid #e1e4eb;
  border-radius: 5px;
  background-color: #f3f7fa;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
  color: white;
  padding: 3px 10px;
}
.OpportunityTitleAndDate{
  padding:5px 20px;
}
.kt-portlet--tabs{
  padding: 0px 0px;
}
.OpportunityDates.d-flex.my-3 svg, .OpportunityDates.d-flex.my-3 h5 {
    font-size: 1.05rem;
}
.OpportunityTitleInput {
    font-size: 1.7rem;
    font-weight: normal!important;
    height: 1.5em;
    padding: 3px 10px;
    color:#00a7cb!important;
}
.kt-nav.kt-nav--bold .kt-nav__item .kt-nav__link .kt-nav__link-text {
    font-weight:normal;
}
.kt-nav.kt-nav--bold .kt-nav__item.active .kt-nav__link .kt-nav__link-text {
    font-weight:600;
}
.kt-nav.kt-nav--md-space .kt-nav__item .kt-nav__link {
    padding-right: 11px;
    padding-left: 11px;
    padding-top: 1.05rem;
    padding-bottom: 1.05rem;
}

.TabItineraryItem-title{
  font-size:1.4rem!important;
}
.kt-nav.kt-nav--md-space .kt-nav__item .kt-nav__link:hover{
    background-color:#f3f7fa!important;
}

.btn-default-edit{
background: #a2a5b9;
}
.kt-badge--beta {
  background-color: #989898 !important;
  color: white;
}
</style>
